import { useEffect, useRef, useState } from 'react';

import {
  isExpectedSyntaxHighlightError,
  requestCodeHighlight,
} from '@/components/ui/smoothdown/components/StaticCode/syntax-highlight.service';
import type {
  SyntaxHighlightLine,
  SyntaxHighlightTheme,
} from '@/components/ui/smoothdown/components/StaticCode/syntax-highlight.types';
import { logError } from '@/lib/errorLogging';

import { ARTIFACT_MOCK_SOURCE } from './artifact-mock-source';

export const GLIDE_MS_PER_PX = 18;

export function useHighlightedMockSource(theme: SyntaxHighlightTheme) {
  const [tokenLines, setTokenLines] = useState<SyntaxHighlightLine[] | null>(
    null
  );

  useEffect(() => {
    const request = requestCodeHighlight({
      code: ARTIFACT_MOCK_SOURCE,
      language: 'tsx',
      theme,
    });
    request.promise.then(setTokenLines).catch((error) => {
      if (isExpectedSyntaxHighlightError(error)) return;
      logError(error, 'Failed to highlight artifact code preview');
    });
    return () => request.cancel();
  }, [theme]);

  return tokenLines;
}

export function useCopyHeight(isMeasurable: boolean) {
  const copyRef = useRef<HTMLDivElement>(null);
  const [copyHeight, setCopyHeight] = useState(0);

  useEffect(() => {
    if (copyRef.current) setCopyHeight(copyRef.current.scrollHeight);
  }, [isMeasurable]);

  return { copyRef, copyHeight };
}
